import {rupiahWithNegative} from 'utils/formatter'
import styles from './Discount.css'

class Discount extends React.Component {
  render () {
    let {paymentDiscounts} = this.props
    return (paymentDiscounts.length > 0 && <div className='row discount-row border-on-bottom'>
      <div className='col-md-12'>
        <label>Discount</label>
        <table className='table mk-table-summary table-truncate'>
          <tbody>
            {paymentDiscounts.map((discount, idxdisc) => (<tr key={idxdisc}>
              <td width='55%' className='name-item-refund tax-grat-disc'>
                { discount.discount_name }
              </td>
              <td width='45%' className={'text-right price text-gray no-border ' + styles['discount-price']}>
                { rupiahWithNegative(-this._calculateDiscount(discount.discount_id)) }
              </td>
            </tr>))}
          </tbody>
        </table>
      </div>
    </div>)
  }
  _calculateDiscount = (discountId) => {
    return this.props.calculateDiscount(discountId)
  }
}

Discount.propTypes = {
  paymentDiscounts: React.PropTypes.array,
  calculateDiscount: React.PropTypes.func
}

export default Discount



// WEBPACK FOOTER //
// ./app/components/receipt/refunds/RefundBreakdownModal/Discount/Discount.js